// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ACCOUNT_INITIALIZE = 'ACCOUNT_INITIALIZE';
export const USER_ACCOUNT = 'USER_ACCOUNT';
export const COMPANY = 'COMPANY';
export const PLAN_ACCOUNT = 'PLAN_ACCOUNT';
export const APPLICATION_THRESHOLD = 'APPLICATION_THRESHOLD';
export const USER_IMAGE = 'USER_IMAGE';

// action - Job Position Reducer
export const JPCARD_INITIALIZE = 'JPCARD_INITIALIZE';
export const BREADCRUMB_MENU_NAVIGATION = "BREADCRUMB_MENU_NAVIGATION";
export const RESET_NAVIGATION = "RESET_NAVIGATION"


// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';
export const MENU_SELECT = '@customization/MENU_SELECT';
// sub - joyride tour 
export const TOUR_LOCATION = "TOUR_LOCATION";

export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const SINGLE_NOTIFICATION_CLEAR = 'SINGLE_NOTIFICATION_CLEAR';

// store/error/actions.js
export const SHOW_ERROR = 'SHOW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
